<template>
  <section class="loading-screen" v-if="showLoading">
    <div class="loading-spinner">
      <h3 class="subtitle is-3 has-text-centered my-6">
        Please wait while we process your order..
      </h3>
      <div class="loader">Loading...</div>
    </div>
  </section>
  <section class="confirm-order" v-if="showConfirm">
    <div class="columns"></div>
    <div class="column"></div>
    <div class="box column">
      <h4>Please confirm your details</h4>
      <p v-if="meterDetails" class="subtitle has-text-centered">
        <span class=""></span> Meter Number:
        <strong>{{ meterDetails.meter_number }}</strong>
      </p>
      <p class="subtitle has-text-centered">
        Meter Details:
        <strong v-if="meterDetails">{{ meterDetails.customer_name }}</strong>
      </p>
      <p>
        Token Value:
        <span class="is-size-6 has-text-weight-bold">{{ zesaunits }} ZWL</span>
      </p>
      <p class="subtitle has-text-centered">
        Cost:
        <strong
          >{{ chosenPMethod === "payfast" ? "R" : "US$"
          }}{{ chosenPAmount }}</strong
        >
      </p>
      <p class="subtitle has-text-centered">
        You are paying using:
        <strong class="is-size-6 has-text-weight-bold"
          >{{ chosenPMethod.toUpperCase() }}
        </strong>
      </p>
      <div class="column"></div>
    </div>

    <div class="columns">
      <div class="column has-text-centered">
        <div
          class="wp-block-button has-custom-width wp-block-button__width-25 has-custom-font-size"
          style="font-size: 15px"
          @click="processPayment"
        >
          <a
            class="wp-block-button__link has-white-color has-text-color has-background wp-element-button"
            style="border-radius: 15px; background-color: #0b4a38"
            ><strong>Continue</strong></a
          >
        </div>
      </div>
      <div class="column has-text-centered">
        <div
          class="wp-block-button has-custom-width wp-block-button__width-25 has-custom-font-size"
          style="font-size: 15px"
          @click="cancelZESAPurchase"
        >
          <a
            class="wp-block-button__link has-white-color has-vivid-red-background-color has-text-color has-background wp-element-button"
            style="border-radius: 20px"
            ><strong>Cancel</strong></a
          >
        </div>
      </div>
    </div>
  </section>
  <ZESABuyError @brokenarrow="sayBrokenArrow" v-if="showZESABuyError" />
</template>

<script>
import ZESABuyError from "./ZESABuyError.vue";
export default {
  name: "ZESAConfirm",
  components: {
    ZESABuyError,
  },
  emits: [
    "zesapurchasecancelled",
    "brokenarrow",
    "hideconfirmbox",
    "hidespinner",
    "showspinner",
  ],

  props: [
    "zesaZARAmount",
    "zesaUSDAmount",
    "zesaunits",
    "chosenPMethod",
    "chosenPAmount",
    "meterDetails",
    "showConfirm",
    "showLoading",
    "zesaEmail",
    "zesaTokenPhone",
  ],

  data() {
    return {
      showZESABuyError: false,
    };
  },
  mounted() {},
  methods: {
    processPayment() {
      //first hide confirm box and show spinner
      this.hideZESAConfirm();
      this.doShowLoading();
      const something = fetch(
        "https://zimpricecheck.com/wp-json/zimpricecheck-bill-payments/1.0.0/process-bill-payment",
        {
          method: "POST", // or 'PUT'
          mode: "cors",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(this.getRequiredFields()),
        }
      )
        .then((res) => res.json())
        .then((data) => {
          if (!data.success) {
            //Everything returns code 200 from our server errors are in the success property

            throw new Error("Some error occured");
          } else if (this.chosenPMethod === "paypal") {
            window.location.replace(data.redirect_to);
          } else if (this.chosenPMethod === "payfast") {
            this.savePayFastDetails(data);
            window.payfast_do_onsite_payment({
              uuid: data.payfast_uuid,
              return_url: data.return_url,
              cancel_url: data.cancel_url,
            });
          }
        })
        .catch((error) => {
          console.log("Error:", error); //Show Error dialogue
          this.hideShowLoading();
          this.doShowZESABuyError();
        });
    },
    getRequiredFields() {
      return {
        email: this.zesaEmail,
        whatsapp_number: this.zesaTokenPhone,
        payment_method: this.chosenPMethod, //set when button is clicked
        amount: this.zesaunits,
        bill_type: "zesa", //We can hard code this as this is only ever going to be ZESA
        meter_number: this.meterDetails.meter_number,
      };
    },
    cancelZESAPurchase() {
      this.$emit("zesapurchasecancelled");
    },
    savePayFastDetails(obj) {
      localStorage.setItem("payfast_complete_data", JSON.stringify(obj));
    },
    payForZESAOrder() {
      //Gather all data should be easy
      //For PayPal check to see redirect URL and redirect to it
      //For PayPast save data to localstorage for later uuiid and launch PayFast model
    },
    sayBrokenArrow() {
      this.$emit("brokenarrow");
    },
    hideZESAConfirm() {
      this.$emit("hideconfirmbox");
    },
    hideShowLoading() {
      this.$emit("hidespinner");
    },
    doShowLoading() {
      this.$emit("showspinner");
    },
    doShowZESABuyError() {
      this.showZESABuyError = true;
    },
  },
  computed: {
    capitalizeFirstLetter(s) {
      /*
      if (s[0]) {
        return s && s[0].toUpperCase() + s.slice(1);
      } else {
        return "";
      } */
      return s;
    },
  },
};
</script>

<style scoped>
.loader,
.loader:after {
  border-radius: 50%;
  width: 10em;
  height: 10em;
}
.loader {
  margin: 60px auto;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 1.1em solid rgba(232, 154, 17, 0.2);
  border-right: 1.1em solid rgba(232, 154, 17, 0.2);
  border-bottom: 1.1em solid rgba(232, 154, 17, 0.2);
  border-left: 1.1em solid #e89a11;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
}
@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
